/* eslint-disable no-restricted-globals */
import { cloneDeep } from "lodash";
import moment from "moment";
import React from "react";
import { FaEye } from "react-icons/fa";
import AppButton from "../../common/AppButton";
import { useNavigate } from "react-router-dom";

const ContractResult = ({ list }) => {
  const navigate = useNavigate();
  const handleView = (data) => {
    navigate(`contracts/view/${data.organization._id}/contract/${data._id}`, {
      state: {
        data: cloneDeep({ ...data }),
      },
    });
  };

  return (
    <div>
      <table className="table table-default">
        <thead>
          <tr>
            <th>Contract ID</th>
            <th>Client</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {list?.map((i) => (
            <tr key={i._id}>
              <td>{i.contractId}</td>
              <td>{i.organization?.name}</td>
              <td>{moment(i.contractStartDate).format("DD/MM/YYYY")}</td>
              <td>{moment(i.contractEndDate).format("DD/MM/YYYY")}</td>
              <td>
                <div
                  className="side-button"
                  style={{ width: 70, borderWidth: 1, display: "flex" }}
                >
                  <AppButton
                    onClick={() => handleView(i)}
                    tooltip="More Details"
                    className="text-primary"
                    leftIcon={<FaEye />}
                  />

                  {/* <AppButton
                    onClick={() => handleDelete(i)}
                    tooltip="Delete Job"
                    className="text-primary"
                    leftIcon={<BiTrash />}
                  /> */}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContractResult;
